import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Restaurant"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.75 1.49985H8.25V8.99985H6.75V1.49985ZM16.5 1.49985H15.75V22.4999H17.25V14.9999H19.5C20.3284 14.9999 21 14.3283 21 13.4999V5.99985C21.0469 4.79261 20.5879 3.62057 19.7336 2.76628C18.8793 1.91199 17.7072 1.45296 16.5 1.49985ZM10.5 8.24985C10.5 9.9067 9.15685 11.2498 7.5 11.2498C5.84315 11.2498 4.5 9.9067 4.5 8.24985V1.49985H3V8.24985C3.00222 10.444 4.58655 12.3167 6.75 12.6823V22.4998H8.25V12.6823C10.4135 12.3167 11.9978 10.444 12 8.24985V1.49985H10.5V8.24985ZM17.25 13.4998H19.5V5.99982C19.5 5.72232 19.41 3.48732 17.25 3.06732V13.4998Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Restaurant.vue"]]);
